
import { VALUE_ENTER, VALUE_ESCAPE, WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import { WizBasePopUp, WizValidationContainerDirective, WizTextInput, WizValidationErrors, WizFocusManager, WizEventManager, WizEvent, WizTextarea } from '@wizeoo/akm-component-lib';
import { Component, ChangeDetectionStrategy, ViewChild, ElementRef, ChangeDetectorRef, HostListener } from '@angular/core';
import { KeyPair } from '@wizeoo/akm-compute-lib';
import { cloneDeep } from 'lodash-es';

/**
 * donnée de la popUp de gestion des params engine
 */
export interface GeneratorRestrictionPopData {
  key: KeyPair; // données sources
  callback: Function; // callback
  update?: KeyPair; // données modifiées
}


@Component({
  selector: 'generator-restriction-pop',
  templateUrl: './generator-restriction.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeneratorRestrictionPop extends WizBasePopUp {
  
  // dimensions demandées
  public static width: string = '300px';
  public static height: string = '500px';
  


  
  @ViewChild('detailZone', { read: WizValidationContainerDirective, static: false }) validationContainer: WizValidationContainerDirective;


  @ViewChild('tiCode', {read: WizTextInput, static: true}) tiCode: WizTextInput;
  @ViewChild('taValue', {read: WizTextarea, static: true}) taValue: WizTextarea;

  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ENTER && this.isValidable) {
      this.validate();
    }
    if (event.key === VALUE_ESCAPE) {
      this.hide();
    }
  }

  constructor(public elementRef: ElementRef, private cdref: ChangeDetectorRef) {
    super();
  }


  private key: KeyPair; // le param engine
  public isValidable: boolean = true; // Indique si la pop est validable
  

  public show(): void {
    super.show();


    let realData: GeneratorRestrictionPopData = this.datas as GeneratorRestrictionPopData;

    this.key = cloneDeep(realData.key);
    this.callback = realData.callback;

    this.tiCode.wizValue = this.key.r;
    this.taValue.wizValue = this.key.l;
    

    // focus du premier champ
    WizFocusManager.getInstance().wizSetFocus(this.tiCode);

    // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, this, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel);
  }


  /**
   * Modification du model dans la zone de saisie
   * @param e Evenement model change
   */
  private updateModel(e: WizEvent): void {
    // interception des opération sur titre de niveau
    switch (e.component) {
      case this.tiCode:
        this.key.r = this.tiCode.wizValue;
        break;
      case this.taValue:
        this.key.l = this.taValue.wizValue;
        break;
    }
  }


  public validate(): void {
    
    // affichage des erreurs éventuelles
    const errors: WizValidationErrors = this.validationContainer.check(true);
    if(errors.length > 0) {
      return;
    }

    this.datas.update = this.key;
    this.datas.callback(this.datas);
    this.hide();
  }

}
